// @ts-nocheck
import { get, post } from "@insite/client-framework/Services/ApiService";
import { ApiParameters, ApiReturnTypes } from "@store/Framework/Common/Hooks/useReportAPI/useReportAPI";

import { ReportResultModel } from "@store/Framework/Types/types";

const reportingUrl = "/api/v1/reporting";

export async function postApiData(parameter: ApiParameters): Promise<ApiReturnTypes | null> {
    const reportResponse = await post<ApiParameters, ReportResultModel>(`${reportingUrl}/remotereport`, parameter);

    const reportData = JSON.parse(reportResponse.reportData);
    return reportData;
}
